module.exports = __webpack_public_path__ + "static/media/banner.5986b250.svg";